import { useState } from 'react'
const useShareableState = () => {
    const [user, setUser] = useState({})
    return { user, setUser }
}
export default useShareableState